import React, { useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Modal from "react-bootstrap/Modal";
import { CompanyContext } from "../data/company_context_management";
import useCompanyUpdateApi from "../data/use_company_update_api";
import SaveSpinnerButton from "./save_spinner_button";
import companySchema from "../../../yup_schemas/company_schema";
import VisibilityControl from "../../profiles/VisibilityControl";
import WebsiteUrlForm from "./website_url_form";
import TwitterUrlForm from "./twitter_url_form";
import LinkedinUrlForm from "./linkedin_url_form";
import FacebookUrlForm from "./facebook_url_form";

function HeaderForm() {
  const context = useContext(CompanyContext);

  const { company, isUpdating, setOpenEditModal, setGeneralError } = context;

  const { updateCompany } = useCompanyUpdateApi({ ...context });

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(companySchema),
  });

  const closeModal = () => {
    setOpenEditModal(null);
    setGeneralError(null);
  };

  const onSubmit = async (data, event) => {
    /* eslint-disable camelcase */
    event.preventDefault();

    const { display_style_preference } = data;

    const pageConfig = {
      ...company.page_config,
      display_style_preference,
    };

    const submitData = { ...data, page_config: pageConfig };

    updateCompany(submitData);
  };

  return (
    <>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3 row">
            <label htmlFor="name" className="col-sm-3 col-form-label">
              Company Name
            </label>
            <div className="col-sm-9">
              <input
                id="name"
                type="text"
                className={`form-control ${errors?.name ? "is-invalid" : ""}`}
                {...register("name")}
                defaultValue={company.name}
              />
              {errors?.name && <div className="invalid-feedback">{errors?.name?.message}</div>}
            </div>
          </div>
          <div className="mb-3 row">
            <span className="col-sm-3 col-form-label">Profile Visibility</span>
            <div className="col-sm-9">
              <Controller
                name="visibility"
                control={control}
                defaultValue={company.visibility}
                render={({ field }) => <VisibilityControl value={field.value} onChange={field.onChange} />}
              />
            </div>
          </div>
          <div className="mb-3 row">
            <label htmlFor="display_style_preference" className="col-sm-3 col-form-label">
              Display Style Preference
            </label>
            <div className="col-sm-9">
              <select
                className="form-select"
                id="display_style_preference"
                {...register("display_style_preference")}
                defaultValue={company.page_config?.display_style_preference}
              >
                <option value="default">Automatically selected by Qwoted algorithms</option>
                <option value="company">Standard: Showcase your own company&apos;s experts</option>
                <option value="pr_firm">PR Agency: Showcase your clients&apos; experts</option>
              </select>
            </div>
          </div>
          <div className="mb-3 row">
            <label htmlFor="overview" className="col-sm-3 col-form-label">
              Headline
            </label>
            <div className="col-sm-9">
              <input
                id="overview"
                type="text"
                className={`form-control ${errors?.headline_custom ? "is-invalid" : ""}`}
                {...register("headline_custom")}
                defaultValue={company.headline}
                placeholder="Catchy headline to display under company name."
              />
              {errors?.headline_custom && <div className="invalid-feedback">{errors?.headline_custom?.message}</div>}
            </div>
          </div>
          <SaveSpinnerButton
            inactiveText="Save Changes"
            activeText="Saving..."
            isSaving={isUpdating}
            className="btn btn-primary"
            onClick={handleSubmit(onSubmit)}
          />
        </form>

        <hr />

        <WebsiteUrlForm />
        <TwitterUrlForm />
        <LinkedinUrlForm />
        <FacebookUrlForm />
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={closeModal}>
          Close
        </button>
      </Modal.Footer>
    </>
  );
}

export default HeaderForm;
